export default __webpack_public_path__ + "assets/enterprise-two-one.77b2acf8ca61bd72655d04886939d56a.png";